import { createFileRoute, Link } from "@tanstack/react-router";
import { z } from "zod";
import { zodValidator, fallback } from "@tanstack/zod-adapter";
import { useEffect } from "react";
import { XCircle } from "lucide-react";
import { SiteHeader } from "@/components/site-header";
import { SiteFooter } from "@/components/site-footer";
import { AuthGate } from "@/components/auth-gate";
import { stripeService } from "@/lib/services/stripeService";

const search = z.object({
  billing_id: fallback(z.string().optional(), undefined),
});

export const Route = createFileRoute("/billing/cancel")({
  head: () => ({
    meta: [{ title: "ClaimGuard | Payment cancelled" }],
  }),
  validateSearch: zodValidator(search),
  component: () => (
    <AuthGate>
      <BillingCancelPage />
    </AuthGate>
  ),
});

function BillingCancelPage() {
  const { billing_id } = Route.useSearch();
  useEffect(() => {
    if (billing_id) stripeService.cancel(billing_id).catch(() => {});
  }, [billing_id]);
  return (
    <div className="min-h-dvh bg-secondary/30">
      <SiteHeader />
      <div className="container-page py-16">
        <div className="mx-auto max-w-xl rounded-2xl border border-border bg-white p-8 text-center shadow-card">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-secondary text-navy">
            <XCircle className="h-8 w-8" />
          </div>
          <h1 className="mt-4 font-display text-3xl text-navy">Payment cancelled</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            No charges were made. You can try again anytime.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/dashboard"
              className="inline-flex items-center gap-2 rounded-lg border border-border bg-white px-5 py-2.5 text-sm font-semibold text-navy hover:bg-secondary"
            >
              Back to dashboard
            </Link>
            <Link
              to="/negotiation"
              className="inline-flex items-center gap-2 rounded-lg bg-purple-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-purple-700"
            >
              Try again
            </Link>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
